<template>
  <div class="page page-routes-nearby">

    <transition name="fade">
    <div v-if="pageReady">
      <!-- <h2 v-if="isFuture">Future Services Nearby</h2>
      <h2 v-else>Services Nearby</h2> -->

      <!-- Address field -->
      <address-field
        class="mt-3 mb-3 address-field"
        id="textfield-general"
        type="general"
        label="Enter Address"
        name="address"
        :selectAddressItemFunc="selectAddressItem">
      </address-field>

    </div>
    </transition>

    <!-- Map -->
    <transition name="appear">
    <div class="map-container" v-if="pageReady">

      <!-- map info overlays -->
      <div class="map-highlight-div"
        v-show="highlightDiv"
        @click="selectRouteFromList(selectedRouteNo)"
        :style="highlightDiv"
        v-html="highlightHtmlText"></div>
      <div class="map-loading-notice" v-if="ajaxLoading">Loading...</div>

      <gmap-map
          ref="vuegmap"
          id="routes-nearby-map"
          class="google-map"
          v-if="googleMapsReady"
          @idle="mapIdleHandler"
          :center="centerMapLatLng || mapSettings.START_LOCATION"
          :zoom="15"
          :options="{ streetViewControl: false, scaleControl: true, clickableIcons: false, styles: mapsStyles }">

        <!-- GPS geolocation -->
        <gmap-marker
            v-if="geolocation.enabled"
            :position="geolocation.position"
            :icon="iconGPSCircle">
        </gmap-marker>

        <!-- Bounding circle for routes query -->
        <gmap-circle
          v-if="centerMapLatLng"
          :options="{
            strokeColor: '#FF0000',
            strokeOpacity: 0.08,
            fillColor: '#FF0000',
            fillOpacity: 0.04,
            zIndex: -1
          }"
          :radius="apiRadius"
          :center="centerMapLatLng">
        </gmap-circle>

      </gmap-map>
    </div>
    </transition>
    <!-- Map END -->

    <!-- List -->
    <transition name="appear">
    <div class="nearby-routes-list mt-3" :class="{ loading: ajaxLoading }">
      <!-- <a href="#"
        class="my-2"
        v-if="selectedRouteNo > 0"
        @click="resetRoutePreview">Go Back</a> -->
      <button type="button"
        class="btn btn-primary my-2"
        v-if="selectedRouteNo > 0"
        @click="resetRoutePreview">
        Go Back <span class="badge badge-light">X</span>
      </button>

      <div v-for="(item, index) in nearByRoutes"
           class="list-item mb-3"
           :classNA="{ highlighted: selectedRouteNo === item.no }"
           :key="'bus-'+index"
           v-show="selectedRouteNo < 0 || selectedRouteNo === item.no"
           mouseover="mouseoverRouteLineHandler($event, item.no, item.type)"
           mouseout="mouseoutRouteLineHandler"
           @click="previewRouteFromList(item.no)">
        <i class="icon-icon-bus" v-if="item.type === 'bus'"></i>
        <i class="icon-icon-light-rail" v-if="item.type === 'rail'"></i>
        <span
          class="circle-route-name"
          :title="item.route"
          :style="{ 'background-color': item.color,  'color': (item.color === '#29588C' || item.color === '#E4002B') ? '#fff' : '#000' }">{{ item.route }}</span>        
        <span class="route-name">{{ item.name }}</span>
        <div v-if="selectedRouteNo === item.no" class="mt-2" style="text-aling: center">
          <button class="btn btn-block" @click="selectRoute(item.no)">View Route Details</button>
        </div>
      </div>
    </div>
    </transition>
    <div class="loading-txt" v-if="ajaxLoading && nearByRoutes.length < 1">Loading...</div>
    <!-- List END -->

    <!-- links to routes and lines -->
    <all-routes-href-links iconColor="white"></all-routes-href-links>

  </div>
</template>

<script>
// @ is an alias to /src
import { MAP as mapSettings } from '../config/'
import AddressField from '@/components/AddressField'
import AllRoutesHrefLinks from '@/components/AllRoutesHrefLinks'
import mixinCommon from '../mixins/common'
import mixinFilters from '../mixins/filters'
import mixinMap from '../mixins/map'
import routesInfo from '../data/routes-info.json'

let mapOverlay, mapDataLayer, mapDataLayerActive, mapDataLayerBus, mapDataLayerRail, currentMapPosition, previousMapPosition

export default {
  name: 'view-routes-nearby',
  components: {
    AddressField, AllRoutesHrefLinks
  },
  mixins: [mixinCommon, mixinFilters, mixinMap],
  data () {
    return {
      isFuture: window.showFutureRoutes || false,
      pageReady: false,
      mapSettings: mapSettings,
      googleMapsReady: false,
      centerMapLatLng: false,
      selectedRouteNo: -1,
      highlightDiv: false,
      highlightHtmlText: '-',
      nearByRoutes: [],
      nearByBusRoutes: [],
      nearByLightRailRoutes: [],
      selectedRoute: [],
      apiRadius: 800,
      mapBounds: false
    }
  },
  computed: {
    routesData () {
      if (!window.drupalSettings) {
        window.drupalSettings = {
          sdg: {
            routes: routesInfo
          }
        }
      }
      return window.drupalSettings.sdg.routes;
    },
    ajaxLoading () {
      let loadingKeys = this.$store.getters['routes/ajaxLoading'];
      let loading = false
      for (let key in loadingKeys) {
        if (loadingKeys[key]) {
          loading = true
        }
      }
      return loading
    },
    geolocation () {
      return this.$store.getters['geoLocation/response'];
    }
  },
  watch: {
    $route () {
      this.setCenterMapLatlng()
    }

  },
  methods: {
    findDrupalRoute (routeNo) {
      for (let route in this.routesData) {
        if (String(this.routesData[route].title) === String(routeNo)) {
          return this.routesData[route];
        }
      }
      return false;
    },
    findDrupalRouteName (routeNo, alternativeName) {
      let result = alternativeName;
      let match = false
      for (let route in this.routesData) {
        if (String(this.routesData[route].title).trim() === String(routeNo).trim()) {
          result = this.routesData[route];
          match = true;
          break;
        }
      }
      if (match) {
        result = (this.isFuture) ? result.field_new_endpoint.join(" - ") : result.field_old_endpoint.join(" - ")
      }
      return this.capitalize(result);
    },
    setCenterMapLatlng () {
      if (isNaN(this.$route.params.lat) || isNaN(this.$route.params.lng)) {
        return;
      }
      this.centerMapLatLng = { lat: parseFloat(this.$route.params.lat), lng: parseFloat(this.$route.params.lng) }
    },
    selectAddressItem (item) {
      this.$router.push({
          name  : (this.$route.path.substr(0,3) === '/es') ? 'es-routes-nearby' : 'routes-nearby',
          params: { lat: item.lat, lng: item.lng}
        });
    },
    getNearbyRoutes () {
      let center = this.$refs.vuegmap.$mapObject.getCenter()
      let geometryBounds = this.getEnvelopeBounds({ lat: center.lat(), lng: center.lng() }, this.apiRadius)

      // let apiUrl = 'https://gis.vta.org/gis2/rest/services/Marketing/TryVtaOrgRoutes/MapServer/0/query'
      let apiUrl = 'https://gis.vta.org/gis/rest/services/Transit/Update2019NTSPAugust2019_tryvtaorg/MapServer/0/query'
      let options = {
        f: 'geojson',
        where: "1=1",
        returnGeometry: true,
        geometryType: 'esriGeometryEnvelope',
        spatialRel: 'esriSpatialRelIntersects',
        geometry: geometryBounds.west + ',' + geometryBounds.south + ',' + geometryBounds.east + ',' + geometryBounds.north,
        inSR: '4326',
        outSR: '4326',
        datumTransformation: 'D_WGS_1984',
        maxAllowableOffset: 0.0001, /* 0.1 = 11km, 0.01 = 1km, 0.001 = 100m, 0.0001 = 10m */
        outFields: '*'
      }
      let apiParams = Object.keys(options).map(key => key + '=' + options[key]).join('&');

      // signal that API call is still pending
      this.$store.commit('routes/SET_AJAX_LOADING', { key: 'all-routes', loading: true })

      // remove all layers
      this.removeMapLayers();

      // get list of drupal routes with order field less than zero
      let drupalRoutesWithOrder = Object.keys(this.routesData)
                                    // .filter(key => (parseInt(this.routesData[key].field_order) || 0) < 0)
                                    .map(key => this.routesData[key])

      // fetch bus routes, find route no based on line_name, then map and sort
      mapDataLayer.loadGeoJson(apiUrl + '?' + apiParams, { idPropertyName: 'id' }, (features) => {
        this.nearByRoutes = features
          .map((f, i) => {
            let routeNo = '-'
            let objectId = '-'
            let routeColor = '#777777'
            f.forEachProperty( (value, property) => {
              if (property.toLowerCase().indexOf('objectid') > -1) {
                objectId = value
              }
              if (property.toLowerCase().indexOf('line_name') > -1) {
                routeNo = value
              } else if (property.toLowerCase().indexOf('line_name') > -1) {
                routeNo = value
              } else if (property.toLowerCase().indexOf('old_route_color') > -1 && !this.isFuture) {
                routeColor = value
              } else if (property.toLowerCase().indexOf('new_route_color') > -1 && this.isFuture) {
                routeColor = value
              }
            });
            routeNo = (routeNo) ? routeNo : ''
            let matchingDrupalRoute = drupalRoutesWithOrder.find(route => route.title.toLowerCase() === routeNo.toLowerCase())
            return {
              no: routeNo,
              order: (matchingDrupalRoute) ? parseInt(matchingDrupalRoute.field_order || 0) : parseInt(routeNo),
              name: this.findDrupalRouteName(routeNo && '?', "Route " + routeNo),
              route: (matchingDrupalRoute) ? matchingDrupalRoute.field_route_name : routeNo, 
              type: (routeNo === "900" || routeNo === "901" || routeNo === "902") ? 'rail' : 'bus',
              color: routeColor
            }
          })
          .sort((a,b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))

          mapDataLayer.setStyle((feature) => {
            let routeColor = '#777777'
            feature.forEachProperty( (value, property) => {
              if (property.toLowerCase().indexOf('old_route_color') > -1 && !this.isFuture) {
                routeColor = value
              } else if (property.toLowerCase().indexOf('new_route_color') > -1 && this.isFuture) {
                routeColor = value
              }
            });
            return {
              strokeColor: routeColor,
              strokeWeight: 6,
              strokeOpacity: 0.9
            }
          });
        this.$store.commit('routes/SET_AJAX_LOADING', { key: 'all-routes', loading: false })
      });
    },
    getMapBounds () {
      if (!this.$refs.vuegmap.$mapObject) {
        return false
      }
      let zoom = this.$refs.vuegmap.$mapObject.getZoom()
      let bounds = this.$refs.vuegmap.$mapObject.getBounds()
      let northEast = bounds.getNorthEast();
      let southWest = bounds.getSouthWest();
      let northWest = new google.maps.LatLng(northEast.lat(), southWest.lng());
      let southEast = new google.maps.LatLng(southWest.lat(), northEast.lng());
      return {
        north: northEast.lat(),
        east: northEast.lng(),
        south: southWest.lat(),
        west: southWest.lng()
      }
    },
    getEnvelopeBounds (latLng, distanceMeters = 4000) {
      // https://stackoverflow.com/questions/7858905/how-to-take-5-km-points-in-all-directions-of-a-location-geocoding-google-api
      let point = new google.maps.LatLng(latLng.lat, latLng.lng);
      let north = google.maps.geometry.spherical.computeOffset(point, distanceMeters, 0);
      let west  = google.maps.geometry.spherical.computeOffset(point, distanceMeters, -90);
      let south = google.maps.geometry.spherical.computeOffset(point, distanceMeters, 180);
      let east  = google.maps.geometry.spherical.computeOffset(point, distanceMeters, 90);
      let northEast = new google.maps.LatLng(north.lat(), east.lng());
      let northWest = new google.maps.LatLng(north.lat(), west.lng());
      let southEast = new google.maps.LatLng(south.lat(), east.lng());
      let southWest = new google.maps.LatLng(south.lat(), west.lng());
      return { north: northEast.lat(), east: northEast.lng(), south: southWest.lat(), west: southWest.lng() }
    },
    removeMapLayers () {
      mapDataLayerActive.forEach(feature => {
        mapDataLayerActive.remove(feature);
      });
      mapDataLayer.forEach(feature => {
        mapDataLayer.remove(feature);
      });
    },
    calcBoundsDistances (bounds) {
      // calculate bounds X distance and Y distance
      let northWest = new google.maps.LatLng(bounds.north, bounds.west);
      let southWest = new google.maps.LatLng(bounds.south, bounds.west);
      let northEast = new google.maps.LatLng(bounds.north, bounds.east);
      return {
        lat_diff: google.maps.geometry.spherical.computeDistanceBetween(northWest, southWest),
        lng_diff: google.maps.geometry.spherical.computeDistanceBetween(northWest, northEast),
      }
    },
    mapIdleHandler (position) {
      if (this.selectedRouteNo > 0) {
        console.log('Route is selected so no fetch new route data.');
        return
      }
      // if (mapDataLayerBus) {
      //   this.mouseoutRouteLineHandler()
      // }
      let center = this.$refs.vuegmap.$mapObject.getCenter()
      this.mapBounds = this.getEnvelopeBounds({ lat: center.lat(), lng: center.lng() }, this.apiRadius)
      currentMapPosition = this.$refs.vuegmap.$mapObject.getCenter()
      this.centerMapLatLng = { lat: currentMapPosition.lat(), lng: currentMapPosition.lng() };
      if (currentMapPosition && previousMapPosition) {
        let distDiffMeters = google.maps.geometry.spherical.computeDistanceBetween(currentMapPosition, previousMapPosition)
        if (distDiffMeters > 100) { // any change in the map which is greater than 100m
          this.getNearbyRoutes()
        }
      }
      previousMapPosition = this.$refs.vuegmap.$mapObject.getCenter()
    },
    mouseoverRouteLineHandler (event, lineNo, type) {
      this.selectedRouteNo = lineNo;
      // if (type === 'bus') {
      //   mapDataLayerBus.forEach(feature => {
      //     if (feature.getProperty('line_name') === lineNo) {
      //       mapDataLayerBus.overrideStyle(feature, { fillColor: '#000000', strokeColor: '#29588C', zIndex: 1000 });
      //     }
      //   })
      // } else if (type === 'lightrail') {
      //   mapDataLayerRail.forEach(feature => {
      //     if (feature.getProperty('LINE') === lineNo) {
      //       mapDataLayerRail.overrideStyle(feature, { strokeColor: '#29588C', zIndex: 1000 });
      //     }
      //   })
      // }
      return
    },
    mouseoutRouteLineHandler () {
      this.selectedRouteNo = -1;
      this.highlightDiv = false;
      mapDataLayer.revertStyle();
      // mapDataLayerBus.revertStyle();
      // mapDataLayerRail.revertStyle();
    },
    showHighlightText (event, type, isClick) {
      if (event.latLng) {
        let pixel = mapOverlay.getProjection().fromLatLngToContainerPixel(event.latLng);
        this.highlightDiv = { left: (pixel.x+15) +'px', top: pixel.y +'px' }

        let routeNo = '-'
        event.feature.forEachProperty( (value, property) => {
          if (property.toLowerCase().indexOf('line_name') > -1) {
            routeNo = value
          }
        });

        this.highlightHtmlText = (routeNo === "900" || routeNo === "901" || routeNo === "902")
          ? '<i class="icon-icon-bus"></i><span class="ml-2">' + routeNo + '</span>'
          : '<i class="icon-icon-light-rail"></i><span class="ml-2">' + routeNo + '</span>'
          // this.selectedRouteNo = (type === 'bus') ? event.feature.getProperty('line_name') : event.feature.getProperty('LINE');
          // if (type === 'bus') {
          //   mapDataLayerBus.overrideStyle(event.feature, { strokeColor: '#29588C', zIndex: 1000 });
          // }
      }
    },
    previewRouteFromMap (feature) {
      feature.forEachProperty( (value, property) => {
        if (property.toLowerCase().indexOf('line_name') > -1) {
          this.highlightRoutePreview(value)
        }
      });
    },
    previewRouteFromList (routeNo) {
      this.highlightRoutePreview(routeNo)
    },
    highlightRoutePreview (routeNo) {
      // mapDataLayerActive.forEach(feature => {
      //   mapDataLayerActive.remove(feature);
      // });
      mapDataLayer.forEach(feature => {
        let featRouteNo = ''
        feature.forEachProperty( (value, property) => {
          if (property.toLowerCase().indexOf('line_name') > -1) {
            featRouteNo = value
          }
        });
        if (featRouteNo === routeNo) {
          feature.toGeoJson(geoJson => {
            // mapDataLayerActive.addGeoJson(geoJson)
          })
        } else {
          mapDataLayer.overrideStyle(feature, { zIndex: 11 });
          mapDataLayer.overrideStyle(feature, { strokeOpacity: 0, zIndex: 11 });
        }
      })
      // mapDataLayerActive.forEach(feature => {
      //   mapDataLayerActive.overrideStyle(feature, { zIndex: -1 });
      // });
      // mapDataLayer.forEach(feature => {
      //   mapDataLayer.overrideStyle(feature, { zIndex: 11 });
      // });
      this.selectedRouteNo = routeNo
    },
    resetRoutePreview () {
      this.selectedRouteNo = -1
      // mapDataLayerActive.forEach(feature => {
      //   mapDataLayerActive.remove(feature);
      // });
      mapDataLayer.forEach(feature => {
        mapDataLayer.overrideStyle(feature, { strokeOpacity: 1 });
      });
    },
    selectRoute (routeNo) {
      this.$router.push({
          name  : (this.$route.path.substr(0,3) === '/es') ? 'es-routes-all' : 'routes-all',
          params: { routeNo: routeNo.trim()}
        });
    },
    selectRouteFromList (routeNo) {
      this.$router.push({
          name  : (this.$route.path.substr(0,3) === '/es') ? 'es-routes-all' : 'routes-all',
          params: { routeNo: routeNo}
        });
    },
  },
  mounted () {
    this.pageReady = true
    VueGoogleMaps.loaded.then(() => {
      this.setCenterMapLatlng()
      this.googleMapsReady = true
      setTimeout(() => {

        // add mapOverlay placeholder for mouse over events
        mapOverlay = new google.maps.OverlayView();
        mapOverlay.draw = function() {};
        mapOverlay.setMap(this.$refs.vuegmap.$mapObject);

        // setup the map layers and their styles for the geojson data
        mapDataLayer = new google.maps.Data({ map: this.$refs.vuegmap.$mapObject });
        mapDataLayerActive = new google.maps.Data({ map: this.$refs.vuegmap.$mapObject });
        mapDataLayer.setStyle({
          geodesic: true,
          strokeWeight: 5,
          strokeOpacity: 0.7,
          // zIndex: 99
        });
        mapDataLayerActive.setStyle({
          geodesic: true,
          strokeColor: '#000000',
          strokeWeight: 12,
          strokeOpacity: 1,
          // zIndex: 91
        });

        // preview selected route
        mapDataLayer.addListener('click', (event) => {
          this.previewRouteFromMap(event.feature)
          // mapDataLayerActive.forEach(feature => {
          //   mapDataLayerActive.remove(feature);
          // });
          // event.feature.toGeoJson(geoJson => {
          //   mapDataLayerActive.addGeoJson(geoJson)
          // })
          // mapDataLayerActive.forEach(feature => {
          //   mapDataLayerActive.overrideStyle(feature, { zIndex: -1 });
          // });
          // mapDataLayer.forEach(feature => {
          //   mapDataLayer.overrideStyle(feature, { zIndex: 11 });
          // });

          // event.feature.forEachProperty( (value, property) => {
          //   if (property.toLowerCase().indexOf('line_name') > -1) {
          //     this.selectedRouteNo = value
          //   }
          // });
          // this.selectedRoute
          // this.selectedRoute
          // mapDataLayerActive.overrideStyle({ zIndex: -1 });
          // mapDataLayer.overrideStyle({ zIndex: 10 });

          // this.selectedRoute = event.feature.getGeometry().getArray()
          // let geoJson = {
          //   "type": "FeatureCollection",
          //   "features": [event.feature]
          // }
          // mapDataLayerActive.addGeoJson(geoJson)
          // let routeNo = '-'

          // if (!this.isMobile) {selectedRoute
          //   this.selectRouteFromList(event.feature.getProperty('line_name'))
          //   return
          // }
          // this.mouseoutRouteLineHandler()
          // this.showHighlightText(event, 'bus', true);
        });

        // add listener to each geoJson feature on mouse over/out and click
        // https://developers.google.com/maps/documentation/javascript/datalayer#add_event_handlers
        if (!this.isMobile) {
          // mapDataLayer.addListener('mouseover', (event) => {
          //   this.showHighlightText(event);
          // });
          // mapDataLayerBus.addListener('mouseover', (event) => {
          //   this.showHighlightText(event, 'bus');
          // });
          // mapDataLayerRail.addListener('mouseover', (event) => {
          //   this.showHighlightText(event, 'lightrail');
          // });
          // mapDataLayerBus.addListener('mouseout', (event) => {
          //   this.mouseoutRouteLineHandler()
          // });
          // mapDataLayerRail.addListener('mouseout', (event) => {
          //   this.mouseoutRouteLineHandler()
          // });
        }
        // mapDataLayerBus.addListener('click', (event) => {
        //   if (!this.isMobile) {selectedRoute
        //     this.selectRouteFromList(event.feature.getProperty('line_name'))
        //     return
        //   }
        //   this.mouseoutRouteLineHandler()
        //   this.showHighlightText(event, 'bus', true);
        // });
        // mapDataLayerRail.addListener('click', (event) => {
        //   if (!this.isMobile) {
        //     this.selectRouteFromList(event.feature.getProperty('LINE'))
        //     return
        //   }
        //   this.mouseoutRouteLineHandler()
        //   this.showHighlightText(event, 'lightrail', true);
        // });

        // fetch the bus and rail from ArcGIS API
        // this.getNearbyBusRoutes();
        // this.getNearbyLightRailRoutes();
        this.getNearbyRoutes()

      }, 100)
    })
  }
}
</script>

<style type="scss" scoped>
.map-highlight-div {
  position: absolute;
  z-index: 9999;
  color: #333;
  padding: 5px;
  font-weight: bold;
  min-width: 40px;
  text-align: center;
  background-color: #fff;
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);
}

.icon-icon-bus, .icon-icon-light-rail {
  font-size:32px;
  min-width: 32px;
  display: inline-flex;
  vertical-align: middle;
  margin-left: 8px;
  margin-right: 12px;
}

.loading {
  opacity: 0.5;
}

.highlighted {
  background-color: #ccc;
}
</style>


// WEBPACK FOOTER //
// src/views/RoutesNearby.vue